import polyglotI18nProvider from "ra-i18n-polyglot";
import englishMessages from "ra-language-english";

// recreate I18n provider with allowMissing option enabled to prevent missing keys errors on console
// @see https://github.com/marmelab/react-admin/issues/758#issuecomment-684611947
export const i18nProvider = polyglotI18nProvider(() => englishMessages, "en", {
  allowMissing: true,
  onMissingKey: (key, _, __) => key
});
